import React from "react";
import { Clock } from "lucide-react";

export const HoursBlock = ({ t }) => (
  <div data-testid="hours-block" className="mt-8 border border-white/15 p-5 md:p-6">
    <div className="flex items-center gap-2.5 mb-4">
      <Clock className="w-5 h-5 text-brand-accent" strokeWidth={2.2} />
      <h3 className="font-display font-bold text-base tracking-wide uppercase">
        {t.contact.hoursTitle}
      </h3>
    </div>
    <div className="space-y-2.5 font-body text-sm md:text-base">
      <div className="flex items-baseline justify-between gap-4 border-b border-white/10 pb-2.5">
        <span className="text-slate-300">{t.contact.monSat}</span>
        <span className="font-display font-bold text-white">{t.contact.monSatHours}</span>
      </div>
      <div className="flex items-baseline justify-between gap-4">
        <span className="text-slate-300">{t.contact.sun}</span>
        <span className="font-display font-bold text-white">{t.contact.sunHours}</span>
      </div>
    </div>
  </div>
);
